import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';
import { getCSRFToken } from '@leaftrade/leaftrade-component-library';
import {
  newToastNotification,
  ToastType,
} from '../dashboard/components/ToastNotifications/toasts';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: '/dashboard/api',
  credentials: 'include',
  prepareHeaders: (headers) => {
    const csrfToken = getCSRFToken();
    if (csrfToken) {
      headers.set('X-CSRFToken', csrfToken);
    }
    return headers;
  },
});

const baseQueryWithToast: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  if (result.error) {
    const errors = (
      result.error.data as
        | { errors?: Array<{ message?: string } | string> }
        | undefined
    )?.errors;
    const errorMessage =
      errors && Array.isArray(errors) && errors.length > 0
        ? errors
            .map((error) =>
              typeof error === 'object' && error !== null && 'message' in error
                ? error.message
                : String(error)
            )
            .join(', ')
        : 'An error occurred';

    newToastNotification({
      body: errorMessage,
      toastType: ToastType.ERROR,
    });
  }

  return result;
};

export const internalDashboardApiBase = createApi({
  reducerPath: 'internalDashboardApi',
  baseQuery: baseQueryWithToast,
  endpoints: () => ({}),
  tagTypes: [],
});
